module.exports = __webpack_public_path__ + "media/images/phone-bell-4cb3eaa0ad282eeb1cc1bf1911291826.jpg";